import { ComponentType } from 'react';

import LeadTassoMutuoPanel from '../leadTasso/LeadTassoMutuoPanel';
import { AcquisitionActivityStore } from './acquisitionActivity';
import { AcquisitionProductId } from './acquisitionProducts';
import { AcquisitionSessionStore } from './acquisitionSessions';
import CdqPanel from './cdq/CdqPanel';
import PrestitoPanel from './prestito/PrestitoPanel';

export interface AcquisitionPanelProps {
  product: AcquisitionProductId;
  /** Where the product's unfinished draft and command identity outlive the tab. */
  sessions: AcquisitionSessionStore;
  /** What the panel tells the workspace it is doing and would lose. */
  activity: AcquisitionActivityStore;
}

/**
 * The panel each registered product is acquired through. This is the single
 * place the workspace learns that a product has a form module, so the
 * workspace itself never learns which products exist.
 */
export const ACQUISITION_PANELS: Record<
  AcquisitionProductId,
  ComponentType<AcquisitionPanelProps>
> = {
  mutui: LeadTassoMutuoPanel,
  prestiti: PrestitoPanel,
  'cessioni-del-quinto': CdqPanel,
};
